import React from "react";
import FirstPart from "./FirstPart";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <FirstPart />
    </footer>
  );
}

export default Footer;
